
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"27"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h18.364v26.239H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#0a294a","d":"M18.364 8.726v8.316c0 2.54-.892 4.708-2.677 6.504-1.786 1.796-3.948 2.694-6.489 2.694-2.542 0-4.71-.898-6.505-2.694C.897 21.75 0 19.582 0 17.042v-8.19l.032-.127C.136 6.29 1.076 4.227 2.85 2.537 4.625.846 6.741 0 9.198 0s4.572.846 6.347 2.536c1.775 1.69 2.714 3.754 2.82 6.19m-4.536-4.19c-1.282-1.282-2.826-1.921-4.631-1.921-1.806 0-3.355.64-4.647 1.92C3.26 5.817 2.615 7.36 2.615 9.166c0 1.807.645 3.355 1.936 4.646 1.292 1.293 2.84 1.938 4.647 1.938 1.805 0 3.349-.645 4.63-1.938 1.281-1.291 1.922-2.84 1.922-4.645 0-1.807-.64-3.35-1.921-4.632M5.26 19.16a7.076 7.076 0 003.938 1.167 7 7 0 003.921-1.167c1.187-.779 2.064-1.8 2.631-3.062v-.505c-1.806 1.851-3.99 2.777-6.552 2.777-2.583 0-4.778-.926-6.583-2.777v.505c.567 1.261 1.449 2.283 2.646 3.062m0 3.126a6.266 6.266 0 003.937 1.339 6.27 6.27 0 003.938-1.34 6.491 6.491 0 002.33-3.416c-1.7 1.847-3.79 2.772-6.268 2.772-2.479 0-4.567-.925-6.269-2.772a6.48 6.48 0 002.332 3.417"}})])])
          )
        }
      }
    